import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import LanguageSwitcher from "@/components/app/LanguageSwitcher";

/**
 * Appearance settings — currently the language switcher only. Reserved for a
 * future dark-mode toggle and accent-colour picker.
 */
export default function SettingsAppearance() {
  const { t } = useTranslation();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-white text-[#0A0B0D] max-w-2xl mx-auto pb-32" data-testid="settings-appearance-page">
      <div className="sticky top-0 z-30 bg-white border-b border-[#E2DFD4]">
        <div className="flex items-center gap-2 px-5 py-5">
          <button onClick={() => nav(-1)} className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full hover:bg-[#F4F1E8]" data-testid="appearance-back" aria-label="Back">
            <ArrowLeft className="w-7 h-7" strokeWidth={3} />
          </button>
          <h1 className="font-display font-black text-[28px] tracking-tight">{t("settings.appearance")}</h1>
        </div>
      </div>

      <section className="px-5 pt-6">
        <h2 className="font-display font-black text-lg mb-2">{t("settings.language")}</h2>
        <p className="text-sm text-[#7C828D] mb-4">{t("settings.languageHint")}</p>
        <LanguageSwitcher />
      </section>
    </div>
  );
}
